import { useCallback, useState } from 'react';
import { useInterval } from './useInterval';

interface CarouselOptions {
  length: number;
  intervalMs?: number;
  paused?: boolean;
}

interface CarouselApi {
  index: number;
  goTo: (index: number) => void;
  next: () => void;
  previous: () => void;
}

export const useCarousel = ({
  length,
  intervalMs = 5000,
  paused = false,
}: CarouselOptions): CarouselApi => {
  const [index, setIndex] = useState(0);

  const goTo = useCallback(
    (next: number) => {
      if (length === 0) return;
      setIndex(((next % length) + length) % length);
    },
    [length],
  );

  const next = useCallback(() => goTo(index + 1), [goTo, index]);
  const previous = useCallback(() => goTo(index - 1), [goTo, index]);

  useInterval(next, paused || length < 2 ? null : intervalMs);

  return { index, goTo, next, previous };
};
